/**
 * Shared top-of-card frost / status tinge colors.
 * Prefer `tone` over ad-hoc rgba strings; pass `colors` only for one-offs.
 */

export type FrostTone =
  | 'default'
  | 'blue'
  | 'purple'
  | 'green'
  | 'red'
  | 'amber'
  | 'teal';

export type FrostColors = readonly [string, string];

/** Default strip height; compact list cards use FROST_HEIGHT_COMPACT. */
export const FROST_HEIGHT = 36;
export const FROST_HEIGHT_COMPACT = 28;

const TONES: Record<FrostTone, { light: FrostColors; dark: FrostColors }> = {
  default: {
    light: ['rgba(59, 130, 246, 0.5)', 'rgba(59, 130, 246, 0)'],
    dark: ['rgba(147, 197, 253, 0.5)', 'rgba(147, 197, 253, 0)'],
  },
  blue: {
    light: ['rgba(59, 130, 246, 0.8)', 'rgba(59, 130, 246, 0)'],
    dark: ['rgba(99, 102, 241, 0.8)', 'rgba(99, 102, 241, 0)'],
  },
  purple: {
    light: ['rgba(139, 92, 246, 0.7)', 'rgba(139, 92, 246, 0)'],
    dark: ['rgba(167, 139, 250, 0.7)', 'rgba(167, 139, 250, 0)'],
  },
  green: {
    light: ['rgba(34, 197, 94, 0.8)', 'rgba(34, 197, 94, 0)'],
    dark: ['rgba(16, 185, 129, 0.8)', 'rgba(16, 185, 129, 0)'],
  },
  red: {
    light: ['rgba(239, 68, 68, 0.8)', 'rgba(239, 68, 68, 0)'],
    dark: ['rgba(245, 158, 11, 0.8)', 'rgba(245, 158, 11, 0)'],
  },
  amber: {
    light: ['rgba(245, 158, 11, 0.8)', 'rgba(245, 158, 11, 0)'],
    dark: ['rgba(251, 191, 36, 0.8)', 'rgba(251, 191, 36, 0)'],
  },
  teal: {
    light: ['rgba(20, 184, 166, 0.72)', 'rgba(20, 184, 166, 0)'],
    dark: ['rgba(45, 212, 191, 0.72)', 'rgba(45, 212, 191, 0)'],
  },
};

/**
 * Resolve frost gradient stops.
 * @param theme true = light UI, false = dark UI (matches themeSelector())
 */
export function getFrostColors(
  tone: FrostTone = 'default',
  theme: boolean = true,
): FrostColors {
  const entry = TONES[tone] ?? TONES.default;
  return theme ? entry.light : entry.dark;
}

export function frostCssLinearGradient(colors: FrostColors): string {
  return `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 100%)`;
}
